import { render, staticRenderFns } from "./CentralRealtimeSection.vue?vue&type=template&id=5ea860ec&scoped=true"
import script from "./CentralRealtimeSection.vue?vue&type=script&lang=js"
export * from "./CentralRealtimeSection.vue?vue&type=script&lang=js"
import style0 from "./CentralRealtimeSection.vue?vue&type=style&index=0&id=5ea860ec&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ea860ec",
  null
  
)

export default component.exports